import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { MAIN_AUTH_CONFIG, MONITORING_AUTH_CONFIG } from '../config/auth';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

axiosInstance.interceptors.request.use(
  config => {
    // Determine which token to use based on the request URL
    const isMonitoringRequest = config.url?.includes('/api/monitoring');
    const tokenKey = isMonitoringRequest
      ? MONITORING_AUTH_CONFIG.tokenKey
      : MAIN_AUTH_CONFIG.tokenKey;

    // Try to get token from the appropriate key, fallback to legacy 'auth_token' if not found
    let token = localStorage.getItem(tokenKey) || sessionStorage.getItem(tokenKey);

    // Fallback to legacy auth_token for backward compatibility
    if (!token) {
      token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    // 401 에러는 authProvider.onError에서 처리하도록 위임
    // axios interceptor에서는 에러만 전파
    return Promise.reject(error);
  }
);

export default axiosInstance;
